<template>
  <v-row justify="end" class="mr-0">
    <v-dialog
        persistent
        v-model="dialog"
        max-width="600px"
    >
      <v-card dark>
        <v-card-title class="secondary">
          <span class="headline">
            {{ $t('users.edit_user_info') }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  large
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('tooltips.close') }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      v-model="dataForModal.password"
                      :label="$t('users.password') + '*'"
                      type="password"
                      :rules="rules.required_length"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                      v-model="dataForModal.verify_password"
                      :label="$t('users.password_again') + '*'"
                      type="password"
                      :rules="rules.password_match"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{ $t('required_fields') }}</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              class="info mr-2"
              dark
              :loading="loading"
              @click="editUser"
          >
            {{ $t('edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
    <v-snackbar
        v-model="snackbar.show"
        :bottom=true
        :color="snackbar.color"
        :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import axios from 'axios';
import i18n from '../../lang/lang'

export default {

  name: "Edit-user-details",
  props: {
    dataForModal: {},
    dialog: false
  },
  data() {
    return {
      snackbar: {
        color: 'error',
        show: false,
        text: '',
        timeout: 5000,
      },
      rules: {
        required: [v => !!v || this.$t('validation.field')],
        required_length: [
          v => !!v || this.$t('validation.field'),
          v => v === '' || this.dataForModal.password.length >= 4 || this.$t('short_password')
        ],
        password_match: [
          v => v === this.dataForModal.password || this.$t('validation.password_match')
        ],
      },
      formError: {},
      loading: false,
      alert: false,
    }
  },
  methods: {
    editUser() {
      if (this.$refs.form.validate()) {
        this.loading = true
        axios.put('/api/users/update_current_user_data', {
          password: this.dataForModal.password,
          verify_password: this.dataForModal.verify_password,
        })
            .then((response) => {
              let data = {
                response: response.data,
              }
              this.$emit('editedUser', data)

              this.closeDialog();
              this.snackbar.color = 'success';
              this.snackbar.text = this.$t('edit_success');
              this.snackbar.show = true;
              this.loading = false
            })
            .catch(error => {
              this.loading = false
              this.$swal.fire({
                type: 'error',
                title: this.$t('validation.error'),
                text: error.response.data.message,
              })
            })
      } else {
        this.snackbar.color = "error"
        this.snackbar.text = this.$t('snackbar_required')
        this.snackbar.show = true;
      }
    },
    changeLocale(locale) {
      i18n.locale = locale;
    },
    closeDialog() {
      this.formError = {}
      this.$refs.form.resetValidation()
      this.$emit('closeEditUserDetailsDialog', false)
    },
  },
}
</script>

<style scoped/>
